<!--AFFICHAGE BLOC GOOGLE -->
<template>
  <v-col md="12" class="pa-3 d-flex flex-column" v-if="this.condition()" >
      <a class="anchor" id="blocqualibat"></a>

    <v-card elevation="2">
      <v-card-title>Certification Qualibat</v-card-title>
      <v-card-text>
        <a href="https://www.qualibat.com/" target="_blank">
          <img
              title="Entreprise certifiée Qualibat" src="../../assets/logo_qualibat.png"
          />
        </a>



          <v-alert outlined type="warning" v-if="resiliations != null" style="margin: 10px">
            <p style="font-weight: bold">Attention. Les certificats Qualibat de cette entreprise ont fait l'objet des modifications suivantes.</p>
            <v-simple-table>
              <thead>
              <tr>
                <th class="text-left">
                  Siret
                </th>
                <th class="text-left">
                  Etablissement
                </th>
                <th class="text-left">
                  Décision
                </th>

              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="(item, index) in resiliations"
                  :key="index+'_'+item.lib1_noq"
              >
                <td> {{item.siret }}</td>
                <td> {{item.nom }}<br>{{item.adresse }}</td>
                <td> {{item.libelle }}</td>

              </tr>
              </tbody>
            </v-simple-table>
          </v-alert>


        <v-simple-table>
          <tbody>

          <SimpleTr
              v-bind:var="certificats"
              data="qualibatDirigeantPP"
              field="valeur"
              prefix="Dirigeant (PP) : "
          ></SimpleTr>
          <SimpleTr
              v-bind:var="certificats"
              data="qualibatDirigeantPM"
              field="valeur"
              prefix="Dirigeant (PM) : "
          ></SimpleTr>
                    <SimpleTr
              v-bind:var="contact"
              data="qualibatDirigeants"
              field="valeur"
              prefix="Dirigeants : "
          ></SimpleTr>

          <SimpleTr
              v-bind:var="finance"
              data="qualibatChiffreAffaires"
              prefix="Chiffre d'affaire :"
              field="libelle"
          ></SimpleTr>
          <SimpleTr
              v-bind:var="finance"
              data="qualibatCapital"
              field="libelle"
              suffix=" €"
              prefix="Capital : "
          ></SimpleTr>

          <SimpleTr
              v-bind:var="administratif"
              data="qualibatNbSal"
              field="valeur"
              prefix="Effectif :"
          ></SimpleTr>
          <SimpleTr
              v-bind:var="certificats"
              data="qualibatFinValidite"
              field="valeur"
              prefix="Certificat valable jsuqu'au : "
          ></SimpleTr>
            <li v-for="item in qualifications" :key="item.code">
              {{ item.lib }} ({{ item.code }})
            </li>
          <tr>
            <td>URL</td>
            <td> 
              <a v-for="certif in certificatsURL" :key="certif" v-bind:href="certif" target="_blank"> Voir le certificat Qualibat <br></a>
            </td>
          </tr>

          <SimpleTr
              v-bind:var="certificats"
              data="qualibatObservation"
              field="libelle"
              prefix="Résumé : "
          ></SimpleTr>

          <tr v-if="qualifications!=null" >
            <td>Qualifications :</td>

            <td>
              <ul>
                <li v-for="item in qualifications" :key="item.code">
                  {{ item.lib }} ({{ item.code }})
                </li>
              </ul>

            </td>
          </tr>
          <SimpleTr
              v-bind:var="concurrence"
              data="assuranceTravaux"
              field="valeur"
              prefix="Assureur Travaux : "
          ></SimpleTr>

          <SimpleTr
              v-bind:var="concurrence"
              data="assuranceRC"
              field="valeur"
              prefix="Assureur RC : "
          ></SimpleTr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import SimpleTr from "@/components/layout/SimpleTr";

export default {
  name: "Qualibat",
  props: [""],
  components: {
    SimpleTr,

  },
  computed: {
    finance: function () {
      return this.$store.getters.getbloc("finance", "donnees");
    },
    administratif: function () {
      return this.$store.getters.getbloc("administratif", "indicateurs");
    },
    certificats: function () {
      return this.$store.getters.getbloc("certificats", "donnees");
    },
    contact: function () {
      return this.$store.getters.getbloc("contact", "donnees");
    },
    resiliations: function () {
      return this.$store.getters.getbloc("certificats", "donnees", "qualibatResiliations", null, "valeur");
    },
    certificatsURL : function() {
      return this.$store.getters.getbloc("certificats", "donnees", "qualibatCertificatURL", null, "valeur");
    },
    concurrence: function () {
      return this.$store.getters.getbloc("concurrence", "donnees");
    },
    qualifications: function () {
      return this.$store.getters.getbloc("certificats", "donnees", "qualibatQualication", null, "valeur");
    },
  },
  methods: {
    condition() {
      return this.$store.getters.condition("certificats", "donnees" ,"qualibatCertificatURL", "valeur" )  || this.$store.getters.condition("certificats", "donnees" ,"qualibatCertificatRGEURL", "valeur" ) || this.$store.getters.condition("certificats", "donnees" ,"qualibatResiliations", "valeur" );
    },
  },
};
</script>
